export const currentAccount = {
  Liste: {
    fiche: {
      titles: {
        edit_title: 'Fiche du compte courant {{code}}',
        new_title: "Création d'un nouveau compte courant",
        view_title: 'Fiche du compte courant',
        characteristics: 'Caractéristiques',
        rate_management: 'Gestion des taux',
        interest_management: 'Gestion des intérêts',
        agiosManagement: 'Gestion des Agios',
        flow_management: 'Flux',
        cashpool: 'CashPool bancaire',
        billing: 'Facturation',
      },
      buttons: {
        back: 'Annuler',
        save: 'Valider',
        create: 'Créer',
      },
      champ_titles: {
        p_company: 'Société mère',
        c_company: 'Société fille',
        type: 'Type',
        name: 'Nom',
        start_date: 'Date début',
        end_date: 'Date fin',
        cashpool_management: 'Gestion du CashPool',
        state: 'Etat',
        currency: 'Devise',
        interest_management: 'Gestion des intérêts',
        value_date: 'Date de valeur',
        p_account: 'Compte société mère',
        c_account: 'Compte société fille',
        credit_note: 'Note de crédit',
        debit_note: 'Note de débit',
        invoice_counter: 'Compteur facture',
        banking_cashpool:
          'Remontée de mouvements bancaires dans le compte courant',
        email: 'Emails',
        inmail_facturation: 'Facturation par email',
        facturation_ref: 'Référence facturation',
      },
      table_rate: {
        title: 'Selection des taux',
        name: 'Nom',
        margin: 'Marge',
        margin_rate: 'Marge/Taux',
        basis: 'Base',
        fix_var: 'Fixe/Var',
        start_date: 'Date début',
        end_date: 'Date fin',
        debit: 'Débit',
        credit: 'Crédit',
      },
      table_account: {
        title: 'Selection de comptes bancaires',
        state: 'Etat',
        name: 'Code-Nom',
        iban: 'IBAN',
        company: 'Société',
        bank: 'Banque',
        category: 'Catégorie',
        label: 'Libellé',
        sense: 'Sens',
        start_date: 'Date début',
      },
      modal_rate: {
        title: 'Modification du lien du taux',
        start_date: 'Date de début',
        end_date: 'Date de fin',
        debtor: 'Taux des intérêts débiteur',
        creditor: 'Taux des intérêts créditeur',
        floor: 'Montant Floor',
        cap: 'Montant Cap.',
      },
      modal_account: {
        title: 'Modification du lien du compte',
        category: 'Catégorie recherchée',
        label: 'Libellé recherché',
        inverse_sign: 'Inverser le sens du mouvement',
        start_date: 'Date de début',
        value_date: 'Choix date',
      },
      info_modal: {
        title: 'Liste des mot-clés',
        label: {
          now: '<DATE>',
          year: '<DATEQUANTIEME>',
          hour1: '<HEURE>',
          hour2: '<HEURE_LONG>',
          p_company: '<CODESOCIETE_MERE>',
          c_company: '<CODESOCIETE_FILLE>',
          name: '<NOM>',
        },
        value: {
          now: 'Date du jour format AAMMJJ',
          year: 'Année sur 2 caractères suivi du quantième',
          hour1: 'Heure au format HHMMSS',
          hour2: 'Heure au format HHMMSSCCC',
          p_company: 'Code de la société mère',
          c_company: 'Code de la société fille',
          name: 'Nom du compte courant',
        },
      },
    },
    table: {
      header: {
        title: 'Liste des comptes courants',
        new_account: 'Nouveau',
      },
      filters: {
        state: '-Etat-',
        type: '-Type',
      },
      searchInput: {
        caption: 'Rechercher un compte courant par code, nom ou société',
      },
      columns: {
        state: 'Etat',
        name: 'Nom du compte courant',
        parent_company: 'Société mère',
        child_company: 'Société fille',
        type: 'Type',
        balance: 'Solde',
        currency: 'Devise',
        end_date: 'Date de solde',
        date: 'Date de modification',
        credit_rate: 'Taux crédit',
        debit_rate: 'Taux débit',
        periode: 'Période calcul',
      },
      button: {
        history: 'Historique',
        statement: 'Relevé',
      },
    },
    releve: {
      header: {
        title: 'Visualisation du relevé de compte courant {{name}}',
        addfile: 'Importer',
        modal: "Détail de l'opération",
        import: "Import d'un relevé de compte courant",
      },
      fields: {
        label: "Libellé de l'opération",
        amount: 'Montant',
        valueDate: 'Date de valeur',
      },
    },
    history: {
      header: {
        title: 'Historique du compte courant {{name}}',
      },
      columns: {
        label: 'Libellé',
        start_date: 'Date de début',
        end_date: 'Date de fin',
        amount: 'Montant',
        currency: 'Devise',
      },
      modal: {
        title: "Visualition du calcul d'intérêt",
        start_date: 'Date de début de période',
        num_days: 'Nb jours',
        position: 'Position',
        rate: 'Taux',
        debtor_interest: 'Intérêt débiteur',
        creditor_interest: 'Intérêt créditeur',
      },
    },
  },
  Calculation: {
    table: {
      header: {
        title: 'Calcul des comptes courants',
        calculate: 'Lancer le calcul',
      },
      filters: {
        type: '-Type',
      },
      columns: {
        name: 'Nom du compte courant',
        parent_company: 'Société mère',
        child_company: 'Société fille',
        type: 'Type',
      },
      modal: {
        title: 'Calcul de compte courant',
        month_end_calculation: 'Calcul de fin de mois',
        calculate: 'Calculer',
        close: 'Annuler',
        errorMessage: 'Veillez remplir les dates de début et de fin',
        period: 'Période de calcul',
        last_balance_date: 'Date de dernier solde (pour calcul avancé)',
        last_rate_date: 'Date de dernier taux (pour calcul avancé)',
      },
    },
  },
  Analyse: {
    balance_title: 'Soldes des comptes courants',
    analysis_title: 'Analyse des comptes courants',
    header: {
      balance_date: 'Date solde',
      interest_date: "Période d'intérêts",
    },
    columns: {
      debit: 'Condition Sté Emprunteuse',
      credit: 'Condition Sté Préteuse',
      provision_interest: 'Interêt provision',
      final_interest: 'Interêt définitif',
      current_account: 'Comptes courants',
    },
  },
  AccountRemunerer: {
    table: {
      header: {
        title: 'Liste des comptes rémunérés',
        new_account: 'Nouveau',
      },
      filters: {
        state: '-Etat-',
        type: '-Type',
      },
      searchInput: {
        caption: 'Rechercher un compte rémunérés par code, nom ou société',
      },
      columns: {
        state: 'Etat',
        name: 'Nom du compte',
        etab: 'Etablissement',
        company: 'Société',
        credit_rate: 'Taux crédit',

        balance: 'Solde',
        currency: 'Devise',
        end_date: 'Date de solde',
        date: 'Date de modification',
      },
      button: {
        history: 'Historique',
        statement: 'Relevé',
      },
    },
    fiche: {
      new_title: 'Fiche d’un compte rémunéré',
      edit_title: 'Fiche d’un compte rémunéré {{code}}',
      titles: {
        // view_title: 'Fiche du compte courant',
        characteristics: 'Caractéristiques',
        rate_management: 'Gestion des taux',
        interest_management: 'Gestion des intérêts',
        agiosManagement: 'Gestion des Agios',
        flow_management: 'Flux',
        cashpool: 'CashPool bancaire',
        billing: 'Facturation',
      },
      champ_titles: {
        p_company: 'Etablissement financier',
        c_company: 'Société',
        name: 'Nom',

        start_date: 'Date début',
        end_date: 'Date fin',
        state: 'Etat',
        currency: 'Devise',

        interest_management: 'Gestion des intérêts',
        value_date: 'Date de valeur',
        p_account: 'Compte société mère',
        c_account: 'Compte société fille',
        credit_note: 'Note de crédit',
        debit_note: 'Note de débit',
        invoice_counter: 'Compteur facture',
        banking_cashpool:
          'Remontée de mouvements bancaires dans le compte courant',
        email: 'Emails',
        inmail_facturation: 'Facturation par email',
        facturation_ref: 'Référence facturation',
        interest: 'Intérêts',
        modeCalcul: 'Mode Calcul',
        compteSocieter: 'Compte société',
        remote: 'Remontée de mouvements bancaires dans le compte',
      },

      compl_fields: {
        first_interest_date: 'Date premier intérêt',
        init_stmt_btn: 'Initialiser le relevé',
        init_amount: "Solde d'ouverture",
        confirm_purge:
          'Ce compte contient déjà des relevés de valeurs. \nSouhaitez-vous tous les supprimer ? \n\n Attention : cette action est irréversible.',
      },
    },
    visualisation: {
      title: 'Visualisation du relevé de compte rémunéré {{name}} ',
      columns: {
        label: 'Libellé',
        complementary_label: 'Libellé complémentaire',
        reference: 'Référence',
        tiers: 'Tiers',
        document_number: 'N° Pièce',
        category: 'Catégorie',
        transaction_code: 'Code',
        devise: 'Devise',
        operation_date: "Date d'opération",
        value_date: 'Date de valeur',
        debit: 'Débit',
        credit: 'Crédit',
        currency: 'Devise',
      },
    },
  },

  AccountCapital: {
    table: {
      header: {
        title: 'Liste des Contrats de capitalisation',
        new_account: 'Nouveau',
      },
      filters: {
        state: '-Etat-',
        type: '-Type',
      },
      searchInput: {
        caption:
          'Rechercher un contrat de capitalisation par code, nom ou société',
      },
      columns: {
        state: 'Etat',
        name: 'Nom du Contrat de capitalisation',
        etab: 'Etablissement',
        company: 'Société',
        rate: 'Taux',
        date: 'Date début',
        end_date: 'Date Fin',
        balance: 'Solde',
        currency: 'Devise',
        date_modification: 'Date de modification',
      },
      button: {
        history: 'Historique',
        statement: 'Relevé',
      },
    },

    fiche: {
      new_title: "Fiche d'un  contrat de capitalisation",
      edit_title: 'Fiche d’un contrat de capitalisation {{code}}',
      champ_titles: {
        liq: 'Liquidité',
      },
    },
    visualisation: {
      title: 'Visualisation du relevé de contrat de capitalisation',
    },
  },
}

